// İSG Portal — Araç listesi satırının TEK "Belge durumu" göstergesi (en kötüsü önce). Sıralama
// `actor`a göre değişir: taşeronda "Reddedildi", ana firmada "Onay bekliyor" önce
// (`summarizeVehicleDocuments`). SP ve EP kopyaları GL12'de birleşti; metinler her portalın
// kendi `compliance.*` / `vehicles.docStatus.*` anahtarlarından gelir.

import { Check, Hourglass } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { VehicleDocumentDto } from '../api/permits';
import { type VehicleActor, summarizeVehicleDocuments } from '../permits/vehicleRegistry';
import { Tag } from '../ui/Tag';

export function VehicleDocStatus({
  documents,
  actor,
}: {
  documents: readonly VehicleDocumentDto[];
  actor: VehicleActor;
}) {
  const { t } = useTranslation();
  switch (summarizeVehicleDocuments(documents, actor)) {
    case 'none':
      return <Tag color="gray">{t('vehicles.docStatus.none')}</Tag>;
    case 'allApproved':
      return (
        <span className="inline-flex items-center gap-1 text-sm text-muted">
          <Check className="h-4 w-4 text-success" aria-hidden="true" />
          {t('vehicles.docStatus.allApproved')}
        </span>
      );
    case 'pending':
      return <Tag color="gray">{t('permits.docApproval.pending')}</Tag>;
    case 'rejected':
      return <Tag color="red">{t('permits.docApproval.rejected')}</Tag>;
    case 'expired':
      return <Tag color="red">{t('compliance.expired')}</Tag>;
    case 'missingEnd':
      return <Tag color="red">{t('vehicles.docStatus.missingEnd')}</Tag>;
    case 'expiring':
      return (
        <Tag color="gray" icon={<Hourglass aria-hidden="true" />}>
          {t('compliance.expiring')}
        </Tag>
      );
  }
}
